var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-select',{attrs:{"placeholder":"请选择","size":_vm.size},model:{value:(_vm.activeSale),callback:function ($$v) {_vm.activeSale=$$v},expression:"activeSale"}},_vm._l((_vm.saleListOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.location,"value":item.id,"disabled":!item.saleStatus}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }